import type { SessionPort, User } from '../domain/auth'

const makeUpdateSessionUser = (session: SessionPort) => (patch: Partial<User>) => {
	session.patchUser(patch)
}

export { makeUpdateSessionUser }
